// Más Reseñas — script propio. Un archivo para toda la tienda.
(function () {
  'use strict';

  function initReveals() {
    var els = document.querySelectorAll('.mt-reveal');
    if (!els.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('mt-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );
    els.forEach(function (el, i) {
      el.style.setProperty('--mt-reveal-delay', (i % 6) * 80 + 'ms');
      observer.observe(el);
    });
  }

  function initContadores() {
    var els = document.querySelectorAll('.mt-cifra[data-target]');
    if (!els.length) return;
    var animado = function (el) {
      var target = parseFloat(el.getAttribute('data-target')) || 0;
      var decimals = (el.getAttribute('data-target').split('.')[1] || '').length;
      var duracion = 1400;
      var inicio = null;
      function paso(ts) {
        if (!inicio) inicio = ts;
        var progreso = Math.min((ts - inicio) / duracion, 1);
        var ease = 1 - Math.pow(1 - progreso, 3);
        el.textContent = (target * ease).toFixed(decimals);
        if (progreso < 1) requestAnimationFrame(paso);
        else el.textContent = target.toFixed(decimals);
      }
      requestAnimationFrame(paso);
    };
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animado(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.6 }
    );
    els.forEach(function (el) { observer.observe(el); });
  }

  function initGaleriaProducto() {
    var galerias = document.querySelectorAll('[data-mt-galeria]');
    galerias.forEach(function (galeria) {
      var principal = galeria.querySelector('[data-mt-galeria-principal]');
      var minis = galeria.querySelectorAll('[data-mt-galeria-mini]');
      if (!principal || !minis.length) return;
      minis.forEach(function (mini) {
        mini.addEventListener('click', function () {
          var full = mini.getAttribute('data-full');
          var alt = mini.getAttribute('data-alt') || '';
          if (!full) return;
          principal.querySelectorAll('img').forEach(function (img) {
            img.src = full;
            img.alt = alt;
          });
          minis.forEach(function (m) { m.classList.remove('mt-mini-activa'); });
          mini.classList.add('mt-mini-activa');
        });
      });
    });
  }

  function initVariantes() {
    var forms = document.querySelectorAll('[data-mt-form-producto]');
    forms.forEach(function (form) {
      var dataEl = form.querySelector('[data-mt-variantes-json]');
      if (!dataEl) return;
      var variantes;
      try {
        variantes = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }
      var selects = form.querySelectorAll('[data-mt-opcion]');
      var idInput = form.querySelector('input[name="id"]');
      var precioEl = form.querySelector('[data-mt-precio]');
      var precioComparadoEl = form.querySelector('[data-mt-precio-comparado]');
      var botonEl = form.querySelector('[data-mt-boton-comprar]');
      var textoAgotado = form.getAttribute('data-texto-agotado') || 'Agotado';
      var textoComprar = form.getAttribute('data-texto-comprar') || 'Añadir al carrito';
      var scope = form.closest('section') || document;
      var galeriaPrincipal = scope.querySelector('[data-mt-galeria-principal]');
      var ultimaImagenVariante = null;

      function varianteActual() {
        var valores = Array.prototype.map.call(selects, function (s) { return s.value; });
        return variantes.find(function (v) {
          return v.options.every(function (opt, i) { return opt === valores[i]; });
        });
      }

      function actualizar() {
        var v = varianteActual();
        if (!v) return;
        idInput.value = v.id;
        if (precioEl) precioEl.textContent = v.price_formatted;
        if (precioComparadoEl) {
          if (v.compare_at_price_formatted) {
            precioComparadoEl.textContent = v.compare_at_price_formatted;
            precioComparadoEl.style.display = '';
          } else {
            precioComparadoEl.style.display = 'none';
          }
        }
        if (botonEl) {
          botonEl.disabled = !v.available;
          botonEl.textContent = v.available ? textoComprar : textoAgotado;
        }
        if (galeriaPrincipal && v.imagen && v.imagen !== ultimaImagenVariante) {
          ultimaImagenVariante = v.imagen;
          galeriaPrincipal.querySelectorAll('img').forEach(function (img) {
            img.src = v.imagen;
            img.alt = v.imagen_alt || img.alt;
          });
        }
      }

      selects.forEach(function (s) { s.addEventListener('change', actualizar); });
      actualizar();
    });
  }

  function initBarraFlotante() {
    var barra = document.querySelector('[data-mt-barra-flotante]');
    if (!barra) return;
    var referencia = document.querySelector('.mt-hero') || document.querySelector('.mt-producto') || document.querySelector('main');
    if (!referencia) return;

    var mostrar = function () { barra.classList.add('mt-barra-visible'); };
    var ocultar = function () { barra.classList.remove('mt-barra-visible'); };

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) ocultar();
            else if (entry.boundingClientRect.top < 0) mostrar();
          });
        },
        { threshold: 0 }
      );
      observer.observe(referencia);
    } else {
      window.addEventListener('scroll', function () {
        if (window.scrollY > 500) mostrar();
        else ocultar();
      });
    }
  }

  function initComparadorAntesDespues() {
    var comparadores = document.querySelectorAll('[data-mt-comparador]');
    comparadores.forEach(function (comp) {
      var handle = comp.querySelector('[data-mt-comparador-asa]');
      var despues = comp.querySelector('[data-mt-comparador-despues]');
      if (!handle || !despues) return;
      var arrastrando = false;

      function mover(clientX) {
        var rect = comp.getBoundingClientRect();
        var pct = Math.min(Math.max((clientX - rect.left) / rect.width, 0), 1) * 100;
        despues.style.width = pct + '%';
        handle.style.left = pct + '%';
      }
      handle.addEventListener('pointerdown', function (e) {
        arrastrando = true;
        handle.setPointerCapture(e.pointerId);
      });
      handle.addEventListener('pointerup', function () { arrastrando = false; });
      handle.addEventListener('pointermove', function (e) {
        if (!arrastrando) return;
        mover(e.clientX);
      });
      comp.addEventListener('click', function (e) { mover(e.clientX); });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveals();
    initContadores();
    initGaleriaProducto();
    initVariantes();
    initComparadorAntesDespues();
    initBarraFlotante();
  });
})();
